import BuoyWeatherChartPanel from '../../features/Buoy/graph/BuoyWeatherChartPanel/BuoyWeatherChartPanel';

const BuoyGraphWidget = () => {
  return (
    <div className="d-flex flex-column h-100 w-100 min-h-0 min-w-0 overflow-hidden">
      <BuoyWeatherChartPanel />
    </div>
  );
};

export default BuoyGraphWidget;
